const parseDuration = (millisec) => {
  if (!millisec) return '-'

  return `${(millisec / 1000 / 60 / 60).toFixed(2)} hrs`
};

export default parseDuration;